import transactionsSaga from '~/sagas/transactions/transactions.saga';

export default transactionsSaga;
